var Shopify = Shopify || {};
// ---------------------------------------------------------------------------
// Money format handler
// ---------------------------------------------------------------------------
Shopify.money_format = theme.moneyFormat;
Shopify.formatMoney = function(cents, format) {
  if (typeof cents == 'string') { cents = cents.replace('.',''); }
  var value = '';
  var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
  var formatString = (format || this.money_format);

  function defaultOption(opt, def) {
     return (typeof opt == 'undefined' ? def : opt);
  }

  function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = defaultOption(precision, 2);
    thousands = defaultOption(thousands, ',');
    decimal   = defaultOption(decimal, '.');

    if (isNaN(number) || number == null) { return 0; }

    number = (number/100.0).toFixed(precision);

    var parts   = number.split('.'),
        dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
        cents   = parts[1] ? (decimal + parts[1]) : '';

    return dollars + cents;
  }

  switch(formatString.match(placeholderRegex)[1]) {
    case 'amount':
      value = formatWithDelimiters(cents, 2);
      break;
    case 'amount_no_decimals':
      value = formatWithDelimiters(cents, 0);
      break;
    case 'amount_with_comma_separator':
      value = formatWithDelimiters(cents, 2, '.', ',');
      break;
    case 'amount_no_decimals_with_comma_separator':
      value = formatWithDelimiters(cents, 0, '.', ',');
      break;
  }

  return formatString.replace(placeholderRegex, value);
};

async function fetchMultipleRequests(data, url) {
  for(const data_item of data) {
    await fetch(url, {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json;'
      },
      body: JSON.stringify(data_item)
    })
    .then(response => response.json())
    .then(function(json) {
      // GTM Upsell subscription upgrade event
      dataLayer.push({ ecommerce: null });
      dataLayer.push({
        event: 'upsell_subscription_upgrade',
        ecommerce: {
          items: json.items
        }
      });
    });
  }
}

function initSectionProductSlider(element){
  if (element.hasClass('init-slider')){
    var slidesTablet = element.data('slides-tablet');
    var slidesDesktop = element.data('slides-desktop');
    var showDots = element.data('show-dots');
    var wrapper = element.parents('.cfcat-container');
    var arrowPrev = wrapper.find('.cfcat-arrow-prev');
    var arrowNext = wrapper.find('.cfcat-arrow-next');
    element.slick({
      dots: showDots,
      arrows: true,
      infinite: false,
      mobileFirst: true,
      slidesToShow: 1,
      slidesToScroll: 1,
      prevArrow: arrowPrev,
      nextArrow: arrowNext,
      responsive: [
        {
          breakpoint: 640,
          settings: {
            slidesToShow: slidesTablet
          }
        },
        {
          breakpoint: 1200,
          settings: {
            slidesToShow: slidesDesktop
          }
        }
      ]
    });
  }
}

document.addEventListener('DOMContentLoaded', function(){
  // Header scripts

  function set_element_height_into_variable(parent_container, element_to_measure, css_var_name, fallback = "0px") {
    height = $(element_to_measure).outerHeight(true);
    $(parent_container).css(`--${css_var_name}`, height ? height + 'px' : fallback);
  }

  if($('.ch-announcement-bar-container').length){
    set_element_height_into_variable(':root', '.ch-announcement-bar-container', 'announcement_bar_height');
  }

  if ($('.ch-container').length) {
    set_element_height_into_variable(':root', '.ch-container', 'header_height', '60px');
  }
  
  $(window).on('load', function(){
    set_element_height_into_variable(':root', '.ch-container', 'header_height');
    if($('.ch-announcement-bar-container').length){
      set_element_height_into_variable(':root', '.ch-announcement-bar-container', 'announcement_bar_height');
    }
    $('body').removeClass('not-loaded');

    if(window.location.hash) {
      setTimeout(function() {
        var scroll_to = $(window.location.hash).offset().top - $('.ch-container').outerHeight(true);

        if($('.ch-announcement-bar-container').length) {
          scroll_to = scroll_to - $('.ch-announcement-bar-container').outerHeight(true);
        }

        $('html, body').animate({
          scrollTop: scroll_to
        }, 800);
      }, 1);
    }
  });

  $(window).on('resize', function(){
    if($('.ch-announcement-bar-container').length){
      set_element_height_into_variable(':root', '.ch-announcement-bar-container', 'announcement_bar_height');
    };
    if ($('.ch-container').length) {
      set_element_height_into_variable(':root', '.ch-container', 'header_height');
    }
  });

  function check_current_scroll_position() {
    current_scroll = $(window).scrollTop();
    if(current_scroll > 0) {
      $('.ch-container').addClass('scrolled');
    } else {
      $('.ch-container').removeClass('scrolled');
    }
  }

  check_current_scroll_position();

  $(window).on('scroll', function(){
    check_current_scroll_position()
  });

  $(document).on('click', '[data-toggle-mobile-menu]', function(){
    $('.mobile-menu-container').toggleClass('opened');
    $('.ch-container').toggleClass('mobile-menu-opened');
    $('html').toggleClass('disable-scroll');
  });

  // Footer scripts
  $(document).on('click', '[data-toggle-collapsible]', function(e) {
    e.preventDefault();
    collapsible_parent_container = $(this).parents('[data-collapsible-container]');
    $(this).toggleClass('opened');
    collapsible_parent_container.find('[data-collapsible-content]').slideToggle();
  });

  // Banner slider
  if ($('.cbs-slider').length){
    $('.cbs-slider').each(function(){
      if ($(this).hasClass('init-slider')){
        var autoplay = $(this).data('autoplay');
        var autoplaySpeed = $(this).data('autoplay-speed');
        $(this).slick({
          dots: true,
          arrows: false,
          slidesToShow: 1,
          slidesToScroll: 1,
          adaptiveHeight: true,
          autoplay: autoplay,
          autoplaySpeed: autoplaySpeed
        });
      }
    });
  }

  // Featured products slider
  if ($('.cfcat-grid').length){
    $('.cfcat-grid').each(function(){
      initSectionProductSlider($(this));
    });
  }

  // Insta slider
  if ($('.cis-slider').length){
    $('.cis-slider').each(function(){
      if ($(this).hasClass('init-slider')){
        var autoplay = $(this).data('autoplay');
        var autoplaySpeed = $(this).data('autoplay-speed');
        var wrapper = $(this).parent();
        var arrowPrev = wrapper.find('.cis-arrow-prev');
        var arrowNext = wrapper.find('.cis-arrow-next');
        $(this).slick({
          dots: false,
          arrows: true,
          slidesToShow: 4,
          slidesToScroll: 1,
          autoplay: autoplay,
          autoplaySpeed: autoplaySpeed,
          prevArrow: arrowPrev,
          nextArrow: arrowNext,
          responsive: [
            {
              breakpoint: 1600,
              settings: {
                slidesToShow: 3,
                slidesToScroll: 1
              }
            },
            {
              breakpoint: 1024,
              settings: {
                slidesToShow: 2,
                slidesToScroll: 1,
                arrows: false
              }
            },
            {
              breakpoint: 767,
              settings: {
                slidesToShow: 1,
                slidesToScroll: 1,
                arrows: false
              }
            }
          ]
        });
      }
    });
  }

  if ($('.ct-slider').length){
    $('.ct-slider').each(function(){
      if ($(this).hasClass('init-slider')){
        $(this).slick({
          dots: true,
          arrows: false,
          slidesToShow: 3,
          slidesToScroll: 3,
          responsive: [
            {
              breakpoint: 1024,
              settings: {
                slidesToShow: 2,
                slidesToScroll: 2
              }
            },
            {
              breakpoint: 767,
              settings: {
                slidesToShow: 1,
                slidesToScroll: 1
              }
            }
          ]
        });
      }
    });
  }

  if ($('.ci-ingredients-slider').length){
    $('.ci-ingredients-slider').each(function(){
      var autoplay = $(this).data('autoplay');
      var autoplaySpeed = $(this).data('autoplay-speed');
      var arrows = $(this).data('arrows');
      if ($(this).hasClass('init-slider')){
        $(this).slick({
          dots: false,
          arrows: arrows,
          slidesToShow: 4,
          slidesToScroll: 1,
          speed: 500,
          touchThreshold: 50,
          autoplay: autoplay,
          autoplaySpeed: autoplaySpeed,
          responsive: [
            {
              breakpoint: 2000,
              settings: {
                slidesToShow: 3
              }
            },
            {
              breakpoint: 1600,
              settings: {
                slidesToShow: 2
              }
            },
            {
              breakpoint: 1024,
              settings: {
                slidesToShow: 1
              }
            },
            {
              breakpoint: 767,
              settings: {
                slidesToShow: 1
              }
            }
          ]
        });
      }
    });
  }

  $(document).on('click', '[data-toggle-popup]', function(e){
    e.preventDefault();
    popup = $(`[data-popup="${$(this).data('toggle-popup')}"]`);
    popup.fadeToggle().toggleClass('opened');
    $('html').toggleClass('disable-scroll');
  });

  $(document).on('click', '.cpt-popup-container', function(e){
		if(!$(e.target).parents('.cpt-popup-content').length){
			$('.cpt-popup-container').fadeToggle().toggleClass('opened');
			$('html').toggleClass('disable-scroll');
		}
	});

  // Swimlane
  if ($('.swimlane').length){
    $('.swimlane').each(function(){
      var swimlane = $(this)[0];
      let isDown = false;
      let startX;
      let scrollLeft;

      swimlane.addEventListener("mousedown", e => {
        isDown = true;
        swimlane.classList.add("active");
        startX = e.pageX - swimlane.offsetLeft;
        scrollLeft = swimlane.scrollLeft;
      });
      swimlane.addEventListener("mouseleave", () => {
        isDown = false;
        swimlane.classList.remove("active");
      });
      swimlane.addEventListener("mouseup", () => {
        isDown = false;
        swimlane.classList.remove("active");
      });
      swimlane.addEventListener("mousemove", e => {
        if (!isDown) return;
        e.preventDefault();
        const x = e.pageX - swimlane.offsetLeft;
        const walk = x - startX;
        swimlane.scrollLeft = scrollLeft - walk;
      });
    });
  }

  // FAQ Page
  if ($('.custom-faq-page-faq-section').length){
    $(document).on('click','.fp-cpi-block', function(){
      category = $(this).data('category');
      $('.fp-cpi-block').removeClass('active');
      $('.fp-cpf-container').removeClass('visible');
      $(this).addClass('active');
      $('.fp-cpf-container[data-category="'+ category +'"]').addClass('visible');
      $('html,body').animate({
        scrollTop: $('.fp-cpf-container[data-category="'+ category +'"]').offset().top - $('.custom-header-section').outerHeight(true)
      }, 'slow');
    });
  }

  // Buttons
  $(document).on('click', '.custom-button', function(e){
    href = $(this).attr('href');
    if (href && href.includes('#')){
      e.preventDefault();
      $('html,body').animate({
        scrollTop: $(href).offset().top - $('.custom-header-section').outerHeight(true)
      }, 'slow');
    }
  });

  // Text with slider
  if ($('.cptwls-slider').length){
    $('.cptwls-slider').each(function(){
      if ($(this).hasClass('init-slider')){
        var autoplay = $(this).data('autoplay');
        var autoplaySpeed = $(this).data('autoplay-speed');
        $(this).slick({
          dots: false,
          arrows: false,
          slidesToShow: 1,
          slidesToScroll: 1,
          centerMode: true,
          centerPadding: "90px",
          autoplay: autoplay,
          autoplaySpeed: autoplaySpeed,
          mobileFirst: true,
          infinite: true,
          responsive: [
            {
               breakpoint: 767,
               settings: {
                 slidesToShow: 3,
                 slidesToSroll: 1,
                 centerPadding:"0px",
                 centerMode: true
               }
            }
          ]
        });

        $(this).on('beforeChange', function(event, slick, currentSlide, nextSlide){
          if (currentSlide != nextSlide){
            test_slider = $(this).parent().find('.cptwls-text-slider');
            test_slider.find('.cptwls-text').hide();
            test_slider.find('.cptwls-text[data-block-id="'+ nextSlide +'"]').fadeIn(500);
          }
        });
      }
    });
  }

  $(document).on('click', '[data-change-quantity]', function(e) {
    e.preventDefault();
    quantity_change = parseInt($(this).data('change-quantity'));
    quantity_input = $(this).parents('form').find('[name="quantity"]');
    if(!quantity_input.length) {
      quantity_input = $(this).parent().find('[name="updates[]"]');
    }
    current_quantity = parseInt(quantity_input.val());
    new_quantity = current_quantity + quantity_change;
    quantity_input.val(new_quantity).trigger('change');
    $(this).parent().find('[data-current-quantity]').html(new_quantity);
  });

  // AJAX cart

  if($('#shopify-section-custom-cart-drawer').length) {
    $(document).on('submit', '[data-enable-cart-drawer="true"] form[action="/cart/add"]', function(e) {
      e.preventDefault();
      addItemToCart(this);
    });

    $(document).on('click', '[data-toggle-cart-drawer]', function(e) {
      e.preventDefault();
      $('html').toggleClass('disable-scroll cart-drawer-opened');
    });

    $(document).on('click', '[data-remove-item]', function(e) {
      e.preventDefault();
      item_key = $(this).data('remove-item');
      updateCartItem(item_key, 0);
    });

    $(document).on('change', '[data-change-item-quantity]', function(e) {
      quantity = $(this).val();
      console.log($(this));
      item_key = $(this).data('change-item-quantity');
      updateCartItem(item_key, quantity);
    });

    function updateCartItem(key, quantity) {
      fetch(theme.cartRoutes.cartChangeUrl + '.js',{
        method: 'POST',
        headers: {
          'Content-Type': 'application/json;'
        },
        body: JSON.stringify({
          id: key,
          quantity: quantity
        })
      })
      .then(function(response){
        return response.json();
      })
      .then(function(json) {
        if (json.status && json.status !== 200) {
          var error = new Error(json.description);
          error.isFromServer = true;
          throw error;
        }
        renderCartDrawer();
      })
      .catch(function(error) {
        // eslint-disable-next-line no-console
        console.log(error);
      });
    }

    function addItemToCart(form) {
      fetch(theme.cartRoutes.cartAddUrl + '.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
          'X-Requested-With': 'XMLHttpRequest'
        },
        body: theme.Helpers.serialize(form)
      })
      .then(function(response) {
        return response.json();
      })
      .then(function(json) {
        if (json.status && json.status !== 200) {
          var error = new Error(json.description);
          error.isFromServer = true;
          throw error;
        }
        renderCartDrawer();
        openCartDrawer();
      })
      .catch(function(error) {
        // eslint-disable-next-line no-console
        console.log(error);
      });
    }

    function openCartDrawer() {
      $('html').addClass('disable-scroll cart-drawer-opened');
    }

    function renderCartDrawer() {
      var time = Date.now();
      fetch(`/?section_id=custom-cart-drawer&timestamp=${time}`, {
        method: 'GET',
        credentials: 'same-origin',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
          'X-Requested-With': 'XMLHttpRequest'
        }
      }).then(function(response) {
        return response.text();
      }).then(function(text) {
        text_to_html = $.parseHTML(text.replaceAll('\x3C!-- BEGIN static -->','').replaceAll('\x3C!-- END static -->',''));
        section_content = $(text_to_html).html();
        $('#shopify-section-custom-cart-drawer').html(section_content);
        new_cart_count = parseInt($('#shopify-section-custom-cart-drawer [data-current-cart-count]').data('current-cart-count'));
        if(new_cart_count > 0) {
          $('.ch-cart-link').addClass('not-empty');
        } else {
          $('.ch-cart-link').removeClass('not-empty');
        }
        $('[data-cart-count]').html(new_cart_count);
      });
    }

    $(document).on('change', '[name="subscription-switch"]', function() {
      input = $(this)[0];
      input.setAttribute('disabled', 'disabled');
      data_array = [];
      $('.ccds-container').attr('loading', '');
      if($(this)[0].checked){
        // Turn all applicable products to subscription
        $('.ccds-item[data-cart-item-is-subscription="false"][data-cart-item-has-subscription-plans="true"]').each((index,item) => {
          data = {
            line: parseInt(item.dataset.cartItemIndex),
            quantity: parseInt(item.dataset.cartItemQuantity),
            selling_plan: parseInt(item.dataset.cartItemFirstSubscriptionPlanId)
          }
          data_array.push(data);
        });
      } else {
        // Turn all applicable products to one-time purchase
        $('.ccds-item[data-cart-item-is-subscription="true"][data-cart-item-has-subscription-plans="true"]').each((index,item) => {
          data = {
            line: parseInt(item.dataset.cartItemIndex),
            quantity: parseInt(item.dataset.cartItemQuantity),
            selling_plan: null
          }
          data_array.push(data);
        });
      }
      fetchMultipleRequests(data_array, theme.cartRoutes.cartChangeUrl + '.js').then((allResponses) => {
        renderCartDrawer();
      }).catch(error => {
        console.log(error);
      })
    });

    $(document).on('submit', '[data-cart-drawer-upsell-form]', function(e) {
      e.preventDefault();
      $('.ccds-container').attr('loading', '');
      formData = theme.Helpers.serialize(this);
      baseItemKey = this.dataset.baseItemKey;
      // First remove the base item from cart
      fetch(theme.cartRoutes.cartChangeUrl + '.js',{
        method: 'POST',
        headers: {
          'Content-Type': 'application/json;'
        },
        body: JSON.stringify({
          id: baseItemKey,
          quantity: 0
        })
      })
      .then(function(response){
        return response.json();
      })
      .then(function(json) {
        if (json.status && json.status !== 200) {
          var error = new Error(json.description);
          error.isFromServer = true;
          throw error;
        }
        // Then add new upsell product
        fetch(theme.cartRoutes.cartAddUrl + '.js', {
          method: 'POST',
          credentials: 'same-origin',
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
            'X-Requested-With': 'XMLHttpRequest'
          },
          body: formData
        })
        .then(function(response) {
          return response.json();
        })
        .then(function(json) {
          if (json.status && json.status !== 200) {
            var error = new Error(json.description);
            error.isFromServer = true;
            throw error;
          }
          // GTM Upsell upgrade event
          dataLayer.push({ ecommerce: null });
          dataLayer.push({
            event: 'upsell_upgrade',
            ecommerce: {
              items: [
                {
                  item_id: json.product_id,
                  item_name: json.title,
                  item_brand: json.vendor,
                  item_variant: json.id,
                  currency: Shopify.currency.active,
                  price: json.price / 100
                }
              ]
            }
          });
          renderCartDrawer();
        })
        .catch(function(error) {
          // eslint-disable-next-line no-console
          console.log(error);
        });
      })
      .catch(function(error) {
        // eslint-disable-next-line no-console
        console.log(error);
      });
      console.log(baseItemKey);
    });
  }
});

class ProductItem extends HTMLElement {
  constructor() {
    super();
    this.product_id = this.dataset.productId;
    this.elements = {
      optionButtons: this.querySelectorAll(`[data-variant-option][data-product-id="${this.product_id}"]`),
      price: this.querySelector(`[data-variant-price][data-product-id="${this.product_id}"]`),
      compareAtPrice: this.querySelector(`[data-variant-compare-at-price][data-product-id="${this.product_id}"]`),
      subscriptionPrice: this.querySelector(`[data-variant-subscription-price][data-product-id="${this.product_id}"]`),
      subscriptionCompareAtPrice: this.querySelector(`[data-variant-subscription-compare-at-price][data-product-id="${this.product_id}"]`),
      submitButtons: this.querySelectorAll(`[data-product-item-submit-button][data-product-id="${this.product_id}"]`),
      featuredMedia: this.querySelector(`[data-featured-media][data-product-id="${this.product_id}"]`),
      links: this.querySelectorAll(`[data-variant-url][data-product-id="${this.product_id}"]`)
    }
    this.product = JSON.parse(this.querySelector(`[data-product-json][data-product-id="${this.product_id}"]`).innerHTML);
    this.selectedVariant = this.getVariantById(this.querySelector(`[data-item-id][data-product-id="${this.product_id}"]`).value);
    this.selectedOptions = {
      option1: this.selectedVariant.option1,
      option2: this.selectedVariant.option2,
      option3: this.selectedVariant.option3
    };
    this.availableOptions = {};

    if (this.product.options.length > 1) {
      this.updateAvailableOptionsBasedOnVariantId();
    }

    if(this.elements.optionButtons) {
      this.elements.optionButtons.forEach(
        (button) => button.addEventListener('click', this.updateOptions.bind(this))
      );
    }
  }

  updateOptions(event) {
    event.currentTarget.parentNode.childNodes.forEach(button => {
      button.setAttribute('aria-active', false);
    })
    event.currentTarget.setAttribute('aria-active', true);
    this.selectedOptions[event.currentTarget.dataset.optionPosition] = event.currentTarget.dataset.optionValue;
    this.selectedVariant = this.getOptionBasedVariant();
    this.updateVariant();
  }

  getOptionBasedVariant() {
    let variant = this.product.variants.find(variant => {
      return variant.option1 == this.selectedOptions.option1 && variant.option2 == this.selectedOptions.option2 && variant.option3 == this.selectedOptions.option3
    });
    return variant;
  }

  getVariantById(variantId) {
    return this.product.variants.find(variant => {
      return variant.id == variantId;
    })
  }

  getVariantsWithSameOptions() {
    var _this = this;
    let availableVariants = this.product.variants.filter(variant => {
      return variant.available == true;
    });

    let variantsWithSameOptions = availableVariants.filter(variant => {
      var willReturn = false;
      if (variant.option1 && ! willReturn) {
        willReturn = variant.option1 == _this.selectedOptions.option1;
      }
      if (variant.option2 && ! willReturn) {
        willReturn = variant.option2 == _this.selectedOptions.option2;
      }
      if (variant.option3 && ! willReturn) {
        willReturn = variant.option3 == _this.selectedOptions.option3;
      }
      return willReturn;
    });

    return variantsWithSameOptions;
  }

  updateVariant(){
    // Update selected options selected values
    for (const [key, value] of Object.entries(this.selectedOptions)) {
      this.querySelectorAll(`[data-product-id="${this.product_id}"][data-option-position="${key}"][data-option-selected-value]`).forEach(selectedValue => {
        selectedValue.innerHTML = value;
      })
    }
    // Set inputs id
    this.querySelectorAll(`[data-item-id][data-product-id="${this.product_id}"]`).forEach(input => {
      input.value = this.selectedVariant.id;
      input.dispatchEvent(new Event('change'));
    })
    // Update available options
    if (this.product.options.length > 1) {
      this.updateAvailableOptionsBasedOnVariantId();
    }
    // Update image
    if (this.selectedVariant.featured_media) {
      this.elements.featuredMedia?.setAttribute('src', this.selectedVariant.featured_media.preview_image.src);
      this.elements.featuredMedia?.setAttribute('srcset', this.selectedVariant.featured_media.preview_image.src);
    }
    // Update prices
    if (this.elements.price) {
      this.elements.price.innerHTML = Shopify.formatMoney(this.selectedVariant.price);
      if (this.elements.compareAtPrice) {
        if (this.selectedVariant.compare_at_price > this.selectedVariant.price) {
          this.elements.compareAtPrice.innerHTML = Shopify.formatMoney(this.selectedVariant.compare_at_price);
          this.elements.compareAtPrice.style.display = 'block';
        } else {
          this.elements.compareAtPrice.style.display = 'none';
        }
      }
    }

    if (this.elements.subscriptionPrice && this.selectedVariant.selling_plan_allocations.length) {
      this.elements.subscriptionPrice.innerHTML = Shopify.formatMoney(this.selectedVariant.selling_plan_allocations[0].price);
      if (this.elements.subscriptionCompareAtPrice) {
        this.elements.subscriptionCompareAtPrice.innerHTML = Shopify.formatMoney(this.selectedVariant.selling_plan_allocations[0].compare_at_price);
      }
    }

    // Update URL
    this.elements.links.forEach(link => {
      link.setAttribute('href', `/products/${this.product.handle}?variant=${this.selectedVariant.id}`);
    });
    // Update buttons
    this.elements.submitButtons.forEach(button => {
      if (this.selectedVariant.available) {
        button.removeAttribute('disabled');
        var buttonClassList = button.classList;
        var buttonText = '';
        switch (true) {
          case buttonClassList.contains('subscription'):
            buttonText = theme.strings.subscribe;
            break;
          case buttonClassList.contains('preorder'):
            buttonText = theme.strings.preorder;
            break;
          case buttonClassList.contains('is-in-drawer'):
            buttonText = theme.strings.drawerUpsellButton;
            break; 
          default:
            buttonText = theme.strings.addToCart;
        }

        button.querySelector('[data-submit-button-text]').innerHTML = buttonText;
      } else {
        button.setAttribute('disabled', true);
        button.querySelector('[data-submit-button-text]').innerHTML = theme.strings.soldOut;
      }
    });
    // Fire custom event
    this.dispatchEvent(new CustomEvent('updatedProductItemVariant', { detail: {
      variant: this.selectedVariant,
      product: this.product
    }}));
  }

  updateAvailableOptionsBasedOnVariantId() {
    let availableOptions = {
      option1: [],
      option2: [],
      option3: []
    };

    let variantsWithSameOptions = this.getVariantsWithSameOptions();

    for (var i = 1; i <= this.product.options.length; i ++) {
      [...variantsWithSameOptions].forEach(variant => {
        availableOptions[`option${i}`].push(variant[`option${i}`]);
      });

      // Leaving only unique values
      availableOptions[`option${i}`] = [...new Set(availableOptions[`option${i}`])];
    }

    this.updateAvailableOptions(availableOptions);
  }

  updateAvailableOptions(availableOptions) {
    this.elements.optionButtons.forEach(button => {
      button.disabled = !availableOptions[button.dataset.optionPosition].includes(button.dataset.optionValue);
    });
  }
}

customElements.define('product-item', ProductItem);


class ProductPage extends ProductItem {
  constructor() {
    super();
    this.imagesSlider = this.querySelector('[data-main-images-slider]');

    this.sliderNav = {
      prevButton: this.querySelector('[data-slider-nav="prev"]'),
      nextButton: this.querySelector('[data-slider-nav="next"]')
    }

    this.subscriptionAdditionalHTML = this.querySelector('[data-subscription-additional-html]');
    this.subscriptionContainer = this.querySelector('[data-custom-subscription-container]');

    this.initializeSlider();

    this.addEventListener('updatedProductItemVariant', this.updateAdditionalInfo.bind(this));

    if (this.subscriptionAdditionalHTML && this.subscriptionContainer) {
      this.addSubscriptionAdditionalHTML();
    }

    this.variantDiscount = this.querySelector(`[data-variant-discount][data-product-id="${this.product_id}"]`);
    this.variantProfit = this.querySelector(`[data-variant-profit][data-product-id="${this.product_id}"]`)
  }

  updateAdditionalInfo() {
    this.updateUrl();
    this.updatePricePerUnit();
    this.updateSliderImages();
    if (this.variantDiscount) {
      this.updateVariantDiscount();
    }
    if (this.variantProfit) {
      this.updateVariantProfit();
    }
  }

  updateUrl() {
    var queryParams = new URLSearchParams(window.location.search);
    queryParams.set("variant", this.selectedVariant.id);
    var newUrl = window.location.protocol + '//' + window.location.host + window.location.pathname + '?' + queryParams.toString();
    window.history.replaceState({ path: newUrl }, '', newUrl);
  }

  updatePricePerUnit() {
    var quantity_option_index = this.product.options.indexOf('Quantity') || this.product.options.indexOf('quantity');
    if (quantity_option_index > -1) {
      var quantity_option_value = parseInt(this.selectedVariant.options[quantity_option_index]);
      var one_time_price_per_unit = this.selectedVariant.price / quantity_option_value;
      this.style.setProperty('--one-time-price-per-unit', `'${Shopify.formatMoney(one_time_price_per_unit)}'`);
      if(this.selectedVariant.selling_plan_allocations.length) {
        var subscription_plan_price = this.selectedVariant.selling_plan_allocations[0].price;
        var subscription_plan_price_per_unit = subscription_plan_price / quantity_option_value;
        this.style.setProperty('--subscription-price-per-unit', `'${Shopify.formatMoney(subscription_plan_price_per_unit)}'`);
      }
    }
  }

  updateSliderImages() {
    if (this.selectedVariant.featured_media) {
      // this.filterImagesSlider($(this.imagesSlider).slick('getSlick'));
      var slideIndex = $(this.querySelector(`[data-main-media-id="${this.selectedVariant.featured_media.id}"]`)).index();
      $(this.imagesSlider).slick('slickGoTo', slideIndex);
    }
  }

  initializeSlider() {
    var _this = this;
    $(_this.imagesSlider).on('init', function(event, slick) {
      if (_this.selectedVariant.featured_media) {
        // _this.filterImagesSlider(slick);
      }
    });

    $(_this.imagesSlider).slick({
      infinite: false,
      dots: false,
      arrows: true,
      slidesToShow: 1,
      slidesToScroll: 1,
      prevArrow: _this.sliderNav.prevButton,
      nextArrow: _this.sliderNav.nextButton
    });
  }

  filterImagesSlider(slick) {
    var mediaAlt = this.selectedVariant.featured_media.alt || this.product.title;
    // slick.unfilterSlides();
    // slick.filterSlides(`[data-media-alt="${mediaAlt}"]`);
  }

  addSubscriptionAdditionalHTML() {
    var _this = this;
    // Select the node that will be observed for mutations
    const targetNode = this.subscriptionContainer;

    // Options for the observer (which mutations to observe)
    const config = { attributes: false, childList: true, subtree: false };

    // Callback function to execute when mutations are observed
    const callback = (mutationList, observer) => {
      for (const mutation of mutationList) {
        if (mutation.addedNodes[0].classList.contains('rc-container-wrapper')) {
          if (_this.subscriptionContainer.querySelector('[data-widget-container-wrapper] [data-plans-container]')) {
            _this.subscriptionContainer.querySelector('[data-widget-container-wrapper] [data-plans-container]').append(_this.subscriptionAdditionalHTML);
            observer.disconnect();
          }
        }
      }
    };

    // Create an observer instance linked to the callback function
    const observer = new MutationObserver(callback);

    // Start observing the target node for configured mutations
    observer.observe(targetNode, config);
  }

  updateVariantDiscount() {
    if (this.selectedVariant.compare_at_price > this.selectedVariant.price) {
      const priceDifference = this.selectedVariant.compare_at_price - this.selectedVariant.price;
      const discountPercentage = Math.floor((priceDifference / this.selectedVariant.compare_at_price) * 100) + '%';
      this.variantDiscount.innerHTML = theme.strings.offRetail.replaceAll(
        '[discount]',
        discountPercentage
      );
      this.variantDiscount.style.display = 'block';
    } else {
      this.variantDiscount.style.display = 'none';
    }
  }

  updateVariantProfit() {
    if (this.selectedVariant.compare_at_price > this.selectedVariant.price) {
      const priceDifference = this.selectedVariant.compare_at_price - this.selectedVariant.price;
      this.variantProfit.innerHTML = theme.strings.profit.replaceAll(
        '[profit]',
        Shopify.formatMoney(priceDifference)
      );
      this.variantProfit.style.display = 'block';
    } else {
      this.variantProfit.style.display = 'none';
    }
  }
}

customElements.define('product-page', ProductPage);

class TabItems extends HTMLElement {
  constructor() {
    super();

    this.tabs = this.querySelectorAll('[id^="Tab-"]');
    this.tabsContent = this.querySelectorAll(`[id^="TabContent-"]`);

    this.tabs.forEach(
      (tab) => tab.addEventListener('click', this.showTab.bind(this))
    );
  }

  showTab(event) {
    this.tabs.forEach(tab => {
      tab.setAttribute('aria-active', false);
    })
    event.currentTarget.setAttribute('aria-active', true);
    var tabContentId = 'TabContent-' + event.currentTarget.id.replaceAll('Tab-', '');
    this.tabsContent.forEach(tabContent => {
      tabContent.style.display = 'none';
    });
    this.querySelector(`#${tabContentId}`).style.display = 'block';
  }
}

customElements.define('tab-items', TabItems);

class CartDrawerUpsellSlider extends HTMLElement {
  constructor() {
    super();
    this.itemsSlider = this.querySelector('[data-slider]');

    this.sliderNav = {
      prevButton: this.querySelector('[data-slider-nav="prev"]'),
      nextButton: this.querySelector('[data-slider-nav="next"]')
    }

    this.initializeSlider();
  }

  initializeSlider() {
    var _this = this;

    $(_this.itemsSlider).slick({
      infinite: false,
      dots: false,
      arrows: true,
      slidesToShow: 1,
      slidesToScroll: 1,
      prevArrow: _this.sliderNav.prevButton,
      nextArrow: _this.sliderNav.nextButton,
      adaptiveHeight: true
    });
  }
}

customElements.define('cart-drawer-upsell-slider', CartDrawerUpsellSlider);

class SubscriptionProducts extends HTMLElement {
  constructor() {
    super();
    this.sectionId = this.dataset.sectionId;
    this.productSelector = this.querySelector('[data-switch-subscription-product]');

    this.productSelector.addEventListener('change', this.changeSubscriptionProduct.bind(this));
  }

  changeSubscriptionProduct() {
    let _this = this;
    let productHandle = this.productSelector.value;
    fetch(theme.rootUrl + 'products/' + productHandle + '?section_id=' + this.sectionId, {
      method: 'GET',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
        'X-Requested-With': 'XMLHttpRequest'
      }
    }).then(function(response) {
      return response.text();
    }).then(function(text) {
      const div = document.createElement('div');
      div.innerHTML = text;
      let newContent = div.querySelector('subscription-products');
      _this.replaceWith(newContent);
    })
  }
}

customElements.define('subscription-products', SubscriptionProducts);

class VideoContainer extends HTMLElement {
  constructor() {
    super();
    this.videoContainer = this.querySelector('[data-video-container]');
    this.loadVideoButton = this.querySelector('[data-load-video]');

    if (this.loadVideoButton) {
      this.loadVideoButton.addEventListener('click', this.loadVideo.bind(this));
    }
  }

  loadVideo() {
    const videoUrl = this.loadVideoButton.dataset.videoUrl;
    const iframe = document.createElement('iframe');
    iframe.src = videoUrl;
    iframe.setAttribute('allow', 'autoplay; fullscreen');
    iframe.setAttribute('playsinline', 'playsinline');
    iframe.setAttribute('frameborder', 0);

    iframe.classList.add('z-index-1', 'absolute', 'inset-0', 'width-full', 'height-full');

    this.videoContainer.append(iframe);
  }
}

customElements.define('video-container', VideoContainer);
